import FetchApi from "../util/fetchApi";
const fetchApi = new FetchApi();

export default class SageMakerService {
  async getUsageReport() {
    return (await fetchApi.get(`/sageMaker/usage-report`)).data;
  }

  async stopRunningInstance(submitData) {
    return (await fetchApi.post(`/sageMaker/stop`, submitData)).data;
  }

  async getSpaces() {
    return (await fetchApi.get(`/sageMaker/imageList`)).data;
  }

  async upgdateImages(spaces, image) {
    return (await fetchApi.post(`/sageMaker/updateImage`, { spaces, image })).data;
  }

  async deleteSpace(submitData) {
    return (await fetchApi.post(`/sageMaker/delete`, submitData)).data;
  }

  async getPipelines() {
    return (await fetchApi.get(`/sageMaker/pipelineList`)).data;
  }
}
